import React from "react";
import { Row, Col, Card, Image, Placeholder } from "react-bootstrap";
import Logo from "../../assets/img/hvezda.png";
import _params from "../../componets/_params";
import apiEndPoints from "../../componets/json/apiEndPoints.json";

class OAuth2 extends React.Component {
  
  state = {
    code: "",
  };

  getDomainLogin = async (code) => {
    debugger;
    const _res = await this.props._api({
      ...this.props,
      method: apiEndPoints.britex.login.domain.method,
      endpoint: apiEndPoints.britex.login.domain.endPoint.replace(
        "{code}",
        code
      ),
      param: "",
    });

    if (_res.status === 200) {
      this.props.setUser(this.props._decrypt(_res.data));
      localStorage.setItem("u", _res.data);
      window.location.assign(localStorage.getItem("lastPage"));
    }
  };

  

  componentDidMount() {
  
    this.props.setHeaderPage({
      Icon: null,
      Title: null,
      SubTitle: null,
    });

    if (this.props.params.id) {
      this.getDomainLogin(this.props.params.id);
    }
  }

  render() {
    
    return (
      <>
        <div className="c-login-center">
          <Card>
            <Card.Body>
              <Row className="mb-4">
                <Col xs={12}>
                  <span className="h5">
                    <strong>Interní služby</strong>
                  </span>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <Image
                    src={Logo}
                    className="c-login-logo c-login-squircle me-2"
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs={12}>
                  <span className="h5">
                    <strong>Britex</strong>
                  </span>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs={12}>
                  <small>Načítám uživatele...</small>
                  <br />
                  <Placeholder animation="glow">
                    <Placeholder.Button variant="secondary" xs={6} />
                  </Placeholder>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}

export default _params(OAuth2);
